<template>
  <div>
    <div class="fixed-grid has-12-cols">
      <div class="grid">
        <!------------------------- Available Item  -------------------------->
        <article v-if="!!isAvailableItemsOpen || !!isAvailableMainActive"
          class="tile py-0 my-0 is-child box cell is-col-span-5 pt-1"
          :class="(!!isAvailableItemsOpen || !!isAvailableMainActive) ? 'is-col-span-5' : 'is-col-span-0'">

          <div class="is-flex is-justify-content-space-between">

            <div v-if="selectedAddItemsTab == addItemsTabs.butterfly.key"
              class="is-flex is-align-items-center">
              <span class="px-3 is-size-4 has-text-weight-bold">Quote Builder</span>
            </div>
            <div v-if="selectedAddItemsTab == addItemsTabs.templates.key"
              class="is-flex is-align-items-center">
              <span class="px-3 is-size-4 has-text-weight-bold">Templates</span>
            </div>

            <!-- TODO: add back in when we have a way to toggle between quote builder and templates -->
            <!-- <div class="tabs is-medium add-items-tabs">
              <ul>
                <li :class="{'is-active' : selectedAddItemsTab ==addItemsTabs.butterfly.key}"
                  @click="selectedAddItemsTab = addItemsTabs.butterfly.key">
                  <a>Quote Builder</a>
                </li>
                <li :class="{'is-active' : selectedAddItemsTab ==addItemsTabs.templates.key}"
                  @click="selectedAddItemsTab = addItemsTabs.templates.key">
                  <a>Templates</a>
                </li>
              </ul>
            </div> -->

            <div>
              <button class="button is-grey has-text-grey is-small is-rounded px-0 is-ghost mr-1 mt-3"
                @click="handleToggleAvaliableItems">
                <span class="msr msr-24px">
                  close
                </span>
              </button>
            </div>

          </div>

          <!-- when quote builder is selected -->
          <div class="tabs"
            v-if="selectedAddItemsTab == addItemsTabs.butterfly.key"
            style="display: flex; justify-content: space-between; width: 100%;">
            <ul style="display: flex; width: 100%; justify-content: space-between;">
              <li :class="{'is-active': avaliableItemsType == 'PARTS'}"
                @click="setAvaliableItemsType('PARTS')">
                <a :class="{'has-text-grey': avaliableItemsType != 'PARTS'}">
                  <span class="mso mso-24px mr-2">car_tag</span>
                  Parts
                </a>
              </li>
              <li :class="{'is-active': avaliableItemsType == 'LABOUR'}"
                @click="setAvaliableItemsType('LABOUR')">
                <a :class="{'has-text-grey': avaliableItemsType != 'LABOUR'}">
                  <span class="mso mso-24px mr-2">fragrance</span>
                  Labour
                </a>
              </li>
              <li :class="{'is-active': avaliableItemsType == 'OTHER'}"
                @click="setAvaliableItemsType('OTHER')">
                <a :class="{'has-text-grey': avaliableItemsType != 'OTHER'}">
                  <span class="mso mso-24px mr-2">car_repair</span>
                  Mech
                </a>
              </li>
              <li :class="{'is-active': avaliableItemsType == 'MISC'}"
                @click="setAvaliableItemsType('MISC')">
                <a :class="{'has-text-grey': avaliableItemsType != 'MISC'}">
                  <span class="mso mso-24px mr-2">water_drop</span>
                  Misc
                </a>
              </li>
              <li :class="{'is-active': avaliableItemsType == 'SUBLETS'}"
                @click="setAvaliableItemsType('SUBLETS')">
                <a :class="{'has-text-grey': avaliableItemsType != 'SUBLETS'}">
                  <span class="mso mso-24px mr-2">compass_calibration</span>
                  Sublets
                </a>
              </li>
            </ul>
          </div>

          <div v-if="(!!isAvailableItemsOpen || !!isAvailableMainActive)
                 && (avaliableItemsType == 'LABOUR' && isNtar)
                 && selectedAddItemsTab == addItemsTabs.butterfly.key"
            class="is-flex is-align-items-center is-justify-content-space-between mb-2">
            <div />
            <div class="control">
              <label class="radio">
                <input type="radio"
                  name="answer"
                  :checked="isSundry"
                  @click="isSundry = true">
                Sundry
              </label>
              <label class="radio">
                <input type="radio"
                  :checked="!isSundry"
                  @click="isSundry = false"
                  name="answer">
                Standard
              </label>
            </div>
          </div>

          <div v-if="(!!isAvailableItemsOpen || !!isAvailableMainActive)
                 && (avaliableItemsType == 'OTHER')
                 && selectedAddItemsTab == addItemsTabs.butterfly.key"
            class="is-flex is-align-items-center is-justify-content-space-between mb-2">
            <div />
            <div class="control">
              <label class="radio">
                <input type="radio"
                  name="answer"
                  :checked="isLabourOtherNtar"
                  @click="isLabourOtherNtar = true">
                NTAR
              </label>
              <label class="radio">
                <input type="radio"
                  :checked="!isLabourOtherNtar"
                  @click="isLabourOtherNtar = false"
                  name="answer">
                Standard
              </label>
            </div>
          </div>

          <add-items-component v-if="selectedAddItemsTab == addItemsTabs.butterfly.key"
            :value="value"
            :vehicle="vehicle"
            :is-sundry="isSundry"
            :next-line-number="nextLineNumber"
            :is-available-items-active="isAvailableItemsOpen"
            :avaliable-items-type="avaliableItemsType"
            :is-main-active="isAvailableMainActive"
            :selected-sub-sections="localSelectedSubSections"
            :selected-area="selectedArea"
            :is-labour-other-ntar="isLabourOtherNtar"
            :auto-save-enabled="autoSaveEnabled"
            @handleUpdate="handleUpdate" />

          <template-component v-if="selectedAddItemsTab == addItemsTabs.templates.key"
            :quote-times-type="value.labourType"
            :vehicle-body-id="vehicle.bodyId"
            :quote-no="value.quoteNo"
            :rates="value.rates"
            :tags="tags"
            :tag-category-id="tagCategory.tagCategoryID"
            :show-manage-tag="showQuoteTemplate"
            @addRepairQuoteTemplateItems="id => $emit('addRepairQuoteTemplateItems', id)"
            @addTemplateItemsCustom="obj => $emit('handleAddTemplateItemsCustom', obj)" />

        </article>

        <!-- when templates is selected -->

        <article class="cell tile is-child box p-2"
          :class="(!!isAvailableItemsOpen || !!isAvailableMainActive) ? 'is-col-span-7' : 'is-col-span-12'">
          <div class="is-flex is-align-items-center mb-5 is-justify-content-space-between">
            <div class="is-flex is-align-items-end">
              <div>
                <p class="title px-3">Quote Items</p>
              </div>
              <!-- vertical break -->
              <!-- <div class="is-divider-vertical" /> -->

              <div class="is-flex  ml-2">
                <span class="mr-2">Items:</span>
                <span class="has-text-success has-text-weight-bold">
                  {{ $filters.formatCurrency( totalQuoteItems, $userInfo.locale, false, 2) }}
                </span>
              </div>

              <div class="is-flex ml-3"
                v-if="totalQuoteItems != value.totalExGst">
                <span class="mr-2">Grand Total:</span>
                <div class="has-text-success has-text-weight-bold is-underlined is-clickable"
                  @click="handleSummaryClick">
                  <span class="">
                    {{ $filters.formatCurrency( value.totalExGst, $userInfo.locale, false, 2) }}
                  </span>
                </div>
              </div>
            </div>

            <div class="is-flex">

              <!-- view options -->
              <div class="dropdown"
                v-if="!isAvailableItemsOpen && !isAvailableMainActive"
                :class="{'is-active': viewOptionDropdownActive && !isAvailableItemsOpen, 'disabled' : !!isAvailableItemsOpen}"
                v-click-outside="handleOutsideClick">
                <div class="dropdown-trigger">
                  <button class="button is-primary is-outlined mx-1"
                    @click="viewOptionDropdownActive = !viewOptionDropdownActive"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu">
                    <div class="is-flex is-align-items-center"
                      v-if="selectedViewType == viewTypes.tabbedView">
                      <span class="msr msr-20px mr-1">tab</span>
                      <span>Tabs</span>
                    </div>
                    <div class="is-flex is-align-items-center"
                      v-else-if="selectedViewType == viewTypes.multiColView">
                      <span class="msr msr-22px mr-1">view_column</span>
                      <span>Dual</span>
                    </div>
                    <div class="is-flex is-align-items-center"
                      v-else>
                      <span class="msr msr-22px mr-1">view_stream</span>
                      <span>Full</span>
                    </div>
                    <span class="mso mso-24px">
                      keyboard_arrow_down
                    </span>
                  </button>
                </div>
                <div class="dropdown-menu"
                  id="dropdown-menu"
                  role="menu">
                  <div class="dropdown-content">
                    <a href="#"
                      @click="selectedViewType = viewTypes.singleColView"
                      class="dropdown-item is-flex is-align-items-center has-text-primary">
                      <!-- <span class="mdi mdi-view-split-horizontal mdi-20px mr-1" /> -->
                      <span class="msr msr-22px mr-1">view_stream</span>
                      <span>Full Screen</span>
                    </a>
                    <a href="#"
                      @click="selectedViewType = viewTypes.multiColView"
                      class="dropdown-item is-flex is-align-items-center has-text-primary">
                      <!-- <span class="mdi mdi-view-split-vertical mdi-20px mr-1" /> -->
                      <span class="msr msr-22px mr-1">view_column</span>
                      <span>Dual Screen</span>
                    </a>
                    <a href="#"
                      @click="selectedViewType = viewTypes.tabbedView"
                      class="dropdown-item is-flex is-align-items-center has-text-primary">
                      <!-- <span class="mdi mdi-tab mdi-20px mr-1" /> -->
                      <span class="msr msr-20px mr-1">tab</span>
                      <span>Tabbed View</span>
                    </a>
                  </div>
                </div>
              </div>

              <!-- <div class="button mx-1 is-primary"
                :class="{'is-outlined': !isAvailableItemsOpen}"
                @click="handleToggleAvaliableItems">
                <span class="msr msr-24px mr-2 ">
                  no_crash
                </span>
                <span> Builder</span> -->
              <!-- {{ isAvailableItemsOpen ? '- Close' : '+ Add' }} -->
              <!-- </div> -->

              <div v-if="value.parts.filter((p) => p.deleted === false && !p.isNew && (p.partStatus == 'Exp' || p.partStatus == 'Imp')).length > 0 "
                class="button is-outlined mx-1"
                @click="$emit('downloadPartsCheckPrice')"
                :class="value.parts.filter((p) => p.deleted === false && !p.isNew && (p.partStatus == 'Exp' || p.partStatus == 'Imp')).length > 0 ?
                  'is-primary' : `is-outlined-btn-${$theme.name}`">
                <span class="msr msr-24px mr-2 ">
                  currency_exchange
                </span>
                <span>Sync</span>
              </div>

              <div class="tooltip is-tooltip-bottom is-tooltip-multiline"
                style="text-align : center;"
                :data-tooltip="value.isAudaNet ? 'To adjust a line, please remove it in AudaNet and\ndownload it to FQ.' : 'Adjust Main Quote Items'">
                <button v-if="value.subQuoteNo > 0 && !isArnieQuote"
                  class="button mx-1 is-success"
                  :disabled="value.isAudaNet"
                  @click="handleToggleAvaliableMainItems">
                  <span class="icon">
                    <i class="mdi"
                      :class="{ 'mdi-adjust' : !isAvailableMainActive, 'mdi-close' : isAvailableMainActive }" />
                  </span>
                  <span>{{ isAvailableMainActive ? 'Done' : 'Adjust' }}</span>
                </button>
              </div>

              <!-- Price parts -->
              <div>
                <button class="button mx-1 is-outlined"
                  :class="canPriceParts ? 'is-success' : `is-outlined-btn-${$theme.name}`"
                  @click="goToPriceParts"
                  :disabled="!canPriceParts">
                  <span class="msr msr-24px">
                    price_check
                  </span>
                  <span>Price Parts</span>
                </button>
              </div>

            </div>
          </div>

          <div class="scrollable-part-items">
            <div class="tabs"
              v-if="selectedViewType == viewTypes.tabbedView && !isAvailableItemsOpen">
              <ul>
                <li :class="{'is-active': selectedTab.id == tab.id}"
                  v-for="(tab) in dataTypes"
                  :key="tab.title"
                  @click="selectedTab = tab">
                  <a>
                    <span>{{ tab.title }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <!-- large/multi row/tab view -->
            <quote-builder-items-view :selected-view-type="selectedViewComputed"
              :selected-tab="selectedTab"
              :view-types="viewTypes"
              :value="value"
              :is-available-items-open="isAvailableItemsOpen"
              :avaliable-items-type="avaliableItemsType"
              :is-present-as-modal-active="isPresentAsModalActive"
              :next-line-number="nextLineNumber"
              :is-editable="isEditable"
              @onOpgCodeChanged="$emit('onOpgCodeChanged')"
              @handleUpdate="handleUpdate"
              @handlePresentAs="handlePresentAs"
              :vehicle="vehicle" />
          </div>
        </article>
      </div>
    </div>

    <!-- Save template Modal -->
    <save-template-modal :active.sync="isTemplateSaveModalActive"
      :data-types="dataTypes"
      :quote="value"
      :vehicle="vehicle"
      :tags="tags" />

    <!-- Present As Modal -->
    <quote-item-present-as-modal v-if="isPresentAsModalActive"
      :active.sync="isPresentAsModalActive"
      v-model="presentAsItem.presentAs"
      :maximum-options="2"
      @ok="onPresentAsOk()"
      @cancel="closePresentAsModal()"
      @close="closePresentAsModal()">
      <p slot="text-title">Present As</p>
    </quote-item-present-as-modal>
  </div>
</template>

<script>
import { ItemCategoryTypes, LabourTimeTypes } from '@/enums'
import QuoteBuilderItemsView from './QuoteBuilderItemsView.vue'
import { QuoteItemPresentAsModal } from '@/components/BulmaModal'
import StoreUtil from '@/store/utils'
import AddItemsComponent from './components/AddItemsComponent.vue'
import cloneDeep from 'lodash.clonedeep'
import { QuoteTotalsMethodMixin } from './mixins'
import QuoteRoutes from '../route-types'
import TemplateComponent from './components/TemplateComponent.vue'
import saveTemplateModal from './components/SaveTemplateModal.vue'
import { EventHubTypes } from '../../../enums'

import TagsService from '../../manageTag/TagsService'
import EventBus from '@/components/EventBus'
import { MENU_MODES as QUOTE_BUILDER_SIDEBAR_MENU_MODES } from '@/components/QuoteBuilderSidebar.vue'

export default {
  name: 'QuoteBuilderView',
  components: {
    QuoteBuilderItemsView,
    QuoteItemPresentAsModal,
    AddItemsComponent,
    QuoteItemPresentAsModal,
    QuoteItemPresentAsModal,
    TemplateComponent,
    saveTemplateModal
  },
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      }
    }
  },
  mixins: [QuoteTotalsMethodMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    nextLineNumber: {
      type: Number,
      default: 0
    },
    vehicle: {
      type: Object,
      required: true
    },
    insurer: {
      type: Object,
      default: null
    },
    showQuoteTemplate: {
      type: Boolean,
      default: false
    },
    selectedSubSections: {
      type: Array,
      default: () => []
    },
    selectedArea: {
      type: String,
      default: null
    },
    isQuoteEditable: {
      type: Boolean,
      default: true
    },
    autoSaveEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isTemplateSaveModalActive: false,
      viewOptionDropdownActive: false,
      isAvailableItemsOpen: false,
      isAvailableMainActive: false,
      avaliableItemsType: 'PARTS',
      dataTypes: [
        { id: 0, key: 'rr', title: 'Remove & Refit', source: 'labours', type: ItemCategoryTypes.RR, source: 'labours' },
        { id: 2, key: 'rep', title: 'Repair', source: 'labours', type: ItemCategoryTypes.REP, source: 'labours' },
        { id: 3, key: 'paint', title: 'Paint', source: 'labours', type: ItemCategoryTypes.PAINT, source: 'labours' },
        { id: 4, key: 'mech', title: 'Mechanical', source: 'others', type: ItemCategoryTypes.MECH, source: 'labours' },
        { id: 5, key: 'part', title: 'Parts', source: 'parts', type: ItemCategoryTypes.PART, source: 'parts' },
        { id: 6, key: 'misc', title: 'Miscellaneous', source: 'miscs', type: ItemCategoryTypes.MISC, source: 'misc' },
        { id: 7, key: 'sublet', title: 'Sublets', source: 'sublets', type: ItemCategoryTypes.SUBL, source: 'sublets' }
      ],
      totals: {
        parts: 0,
        labours: 0,
        others: 0,
        miscs: 0,
        sublets: 0
      },
      // view types for the quote items
      viewTypes: {
        singleColView: 'singleCol',
        multiColView: 'multiCol',
        tabbedView: 'tabView'
      },
      selectedViewType: 'multiCol',
      //just used for tabbed view
      selectedTab: { id: 0, title: 'Remove && Refit', source: 'labours', type: ItemCategoryTypes.RR },
      isPresentAsModalActive: false,
      presentAsItem: null,

      isSundry: false,
      addItemsTabs: {
        butterfly: { key: 1, title: 'Butterfly' },
        templates: { key: 2, title: 'Templates' }
      },
      selectedAddItemsTab: 1,
      tagCategory: {},
      tags: [],
      category: 'QuoteTemplate',
      localSelectedSubSections: [],
      isLabourOtherNtar: false
    }
  },
  computed: {
    routeTypes() {
      return QuoteRoutes
    },

    // Gate for the "Price Parts" button.
    // Autosave ON: any non-deleted part is enough — goToPriceParts() persists unsaved parts before
    //   routing, and autosave keeps them saved. This deliberately does NOT depend on the volatile
    //   isNew flag or the saved baseline, both of which can be left stale by the innerValue/echo
    //   sync and the post-save refresh (which strips isNew items from the baseline), causing the
    //   button to get stuck disabled after adding parts.
    // Autosave OFF: unchanged — needs a saved (non-new) part, so it stays disabled while all items
    //   are new.
    canPriceParts() {
      const liveParts = (this.value.parts || []).filter((p) => p.deleted === false)
      if (liveParts.length === 0) return false
      if (this.autoSaveEnabled) return true
      return liveParts.some((p) => !p.isNew)
    },

    isNtar() {
      if (this.value) {
        return (
          this.value.labourType === LabourTimeTypes.NTAR || this.value.labourType === LabourTimeTypes.LTAR || this.value.labourType === LabourTimeTypes.eMTA
        )
      }
    },
    selectedViewComputed() {
      // return single column view
      if (!this.isAvailableItemsOpen && !this.isAvailableMainActive) return this.selectedViewType
      return this.viewTypes.singleColView
    },
    totalQuoteItems() {
      return (
        this.calculateItemCategoryTotal(this.value.quotingMethod, this.value.labours, ItemCategoryTypes.RR) +
        this.calculateItemCategoryTotal(this.value.quotingMethod, this.value.labours, ItemCategoryTypes.REP) +
        this.calculateItemCategoryTotal(this.value.quotingMethod, this.value.labours, ItemCategoryTypes.PAINT) +
        this.calculateItemCategoryTotal(this.value.quotingMethod, this.value.others, ItemCategoryTypes.MECH) +
        this.calculateItemCategoryTotal(this.value.quotingMethod, this.value.parts, ItemCategoryTypes.PART) +
        this.calculateItemCategoryTotal(this.value.quotingMethod, this.value.miscs, ItemCategoryTypes.MISC) +
        this.calculateItemCategoryTotal(this.value.quotingMethod, this.value.sublets, ItemCategoryTypes.SUBL)
      )
    },
    itemCategoryNames() {
      return this.$company.itemCategories
    },
    isSuppQuote() {
      return this.value && this.value.subQuoteNo ? this.value.subQuoteNo > 0 : false
    },
    // Adjusting main items in a supp causes an amount mismatch when submitted to Arnie
    isArnieQuote() {
      return !!this.insurer && !!this.insurer.arnie
    },
    isEditable() {
      return this.isQuoteEditable
    }
  },
  watch: {
    selectedViewType(val) {
      // check if value matches any of the view types
      if (Object.values(this.viewTypes).includes(val)) {
        StoreUtil.setLocalStorage('quoteBuilder', 'selectedViewType', val)
      }
    },
    selectedSubSections: {
      handler(newVal) {
        this.localSelectedSubSections = [...newVal]
      },
      immediate: true
    }
  },
  mounted() {
    this.$eventHub.$on(EventHubTypes.saveTemplateFromQuote, () => {
      this.handleSaveTemplate()
    })
    this.$eventHub.$on(EventHubTypes.ReloadQuoteTemplate, () => {
      this.getTagsByCategory()
    })
  },
  created() {
    EventBus.$on('subsections-updated', (data) => {
      this.localSelectedSubSections = data
    })
    // get selected view type from local storage
    const selectedViewType = StoreUtil.getLocalStorage('quoteBuilder', 'selectedViewType')
    if (selectedViewType) {
      this.selectedViewType = selectedViewType
    }
    this.getTagsByCategory()
  },
  beforeDestroy() {
    EventBus.$off('subsections-updated')
  },
  methods: {
    userPartsCheckPermission() {
      let isPartsCheck = false
      for (let permissions of this.$user.permissions) {
        if (permissions.codeName == 'A021') {
          isPartsCheck = permissions.hasAccess && !!this.partsCheckSettings && this.partsCheckSettings.property2 == '1'
        }
      }
      return isPartsCheck
    },
    handleSaveTemplate() {
      this.isTemplateSaveModalActive = true
    },
    setAvaliableItemsType(type) {
      // get div with class quote-items-section and scroll to selected type
      // const mechSection = document.querySelector(`.quote-items-section.${type?.toLowerCase()}`)
      // if (mechSection) {
      //   mechSection.scrollIntoView({ behavior: 'smooth' })
      // }
      this.avaliableItemsType = type
      this.$emit('avaliableItemsTypeChanged', type)
    },
    handleAddTemplateItemsCustom(obj) {
      console.log('handleAddTemplateItemsCustom', obj)
    },
    handleOutsideClick() {
      this.viewOptionDropdownActive = false
    },
    handleSummaryClick() {
      this.$router.push({ name: this.routeTypes.QuoteSummary.name, params: { quoteId: this.$route.params.quoteId }, query: this.$route.query })
    },
    handleToggleAvaliableMainItems() {
      this.isAvailableItemsOpen = false
      this.isAvailableMainActive = !this.isAvailableMainActive
    },
    handleToggleAvaliableItems() {
      this.isAvailableMainActive = false
      this.isAvailableItemsOpen = !this.isAvailableItemsOpen
      if (this.isAvailableItemsOpen) {
        this.selectedAddItemsTab = this.addItemsTabs.butterfly.key
      }
      this.$emit('update:selectedMenu', QUOTE_BUILDER_SIDEBAR_MENU_MODES.MANUAL)
    },
    handleUpdate(value) {
      this.$emit('input', value)
    },
    onPresentAsOk() {
      // presentAsItem may be stale if vm.entity was swapped by a concurrent save refresh.
      // Re-find the item in the live value by quoteItemId to ensure the update lands correctly.
      const presentAs = this.presentAsItem?.presentAs
      const itemId = this.presentAsItem?.quoteItemId
      if (itemId && presentAs) {
        const collections = ['labours', 'parts', 'opgs', 'miscs', 'sublets', 'others']
        for (const key of collections) {
          const found = this.value?.[key]?.find(i => i.quoteItemId === itemId)
          if (found) {
            found.presentAs = presentAs
            break
          }
        }
      }
      this.closePresentAsModal()
    },
    closePresentAsModal() {
      this.$nextTick(() => {
        this.isPresentAsModalActive = false
      })
    },
    handlePresentAs(item) {
      if (item) {
        this.presentAsItem = item
        this.presentAsItem.presentAs = this.presentAsItem.presentAs == null ? [] : this.presentAsItem.presentAs
        this.isPresentAsModalActive = true
      }
    },
  goToPriceParts() {
      // TODO: ideally  unordered parts should be (p.quantityOrdered < p.itemQuantity), but i
      // TODO: just leaving it like this as price parts uses this

      const innerValue = cloneDeep(this.value)

      const unorderedParts = innerValue.parts.filter(
        (p) =>
          p.deleted == false &&
          p.partStatus != 'Pord' &&
          (p.quantityOrdered === 0 || p.quantityReturned > p.quantityOrdered || p.quantityOrdered - p.quantityReturned < p.itemQuantity)
      )

      const unSavedParts = innerValue.parts.filter((p) => p.isNew).length

      if (!unorderedParts.length && unSavedParts == 0) {
        this.$toast.open({
          message: 'There are no more parts to order, please add parts before proceeding',
          type: 'is-warning',
          queue: false,
          duration: 5000,
          position: 'is-bottom'
        })
        return
      }
      if (innerValue.parts.filter((p) => p.deleted === false).length > 0) {
        if (innerValue.parts.filter((p) => p.isNew).length > 0) {
         this.$emit('save', false, false, true)
        } else {
          this.$router.push({
            name: QuoteRoutes.QuotePriceParts.name
          })
        }
      }
      this.isPricePartsModalActive = true
    },
    async getTagsByCategory() {
      this.tagCategory = await TagsService.getTagsByCategory(this.category)
      this.tags = this.tagCategory.tags || []
    },
    showQuoteItem() {
      this.isAvailableItemsOpen = false
      this.isAvailableMainActive = false
    },
    showTemplates() {
      this.selectedAddItemsTab = this.addItemsTabs.templates.key
      this.isAvailableItemsOpen = true
      this.isAvailableMainActive = true
    },
    showQuoteBuilder() {
      this.selectedAddItemsTab = this.addItemsTabs.butterfly.key
      this.isAvailableItemsOpen = true
      this.isAvailableMainActive = false
    }
  }
}
</script>

<style lang="scss" >
.full-quote-page-height {
  height: fit-content;
  // 52px for the navbar and 52px for the quote header, 20px for the padding
  min-height: calc(100vh - 52px - 52px - 20px) !important;
}

.cell {
  .title {
    font-size: 1.2em;
    font-weight: bold;
    // margin-bottom: 10px;
    border-bottom: 2px solid rgb(6, 108, 224);
  }

  .row {
    background-color: #eeeeee;
    border: 1px solid #000000;
    padding: 10px;
    margin: 4px;
    border-radius: 5px;
  }
}

.quote-item-heading {
  position: sticky;
  top: 50px;
  z-index: 9;
}

.scrollable-part-items {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 52px - 52px - 110px);
  overscroll-behavior: contain;

  .quote-item-heading {
    position: sticky;
    top: 0px;
    z-index: 9;
  }
}
</style>
